package com.flowyride.core.fileexport

import androidx.compose.runtime.Composable

/** A text file the user picked on their device. */
data class PickedFile(
    val fileName: String,
    val content: String,
)

fun interface FilePicker {
    /** Opens the platform file chooser; the result arrives through the callbacks given to [rememberFilePicker]. */
    fun pick()
}

/**
 * Platform file chooser bound to the current UI host (document picker on mobile, file input on web).
 *
 * @param extensions accepted extensions without dot, e.g. "gpx". Mobile pickers may let any file through:
 *   callers still validate the content.
 * @param onFailed the file could not be read. Cancelling calls neither callback.
 */
@Composable
expect fun rememberFilePicker(
    extensions: List<String>,
    onPicked: (PickedFile) -> Unit,
    onFailed: (Throwable) -> Unit,
): FilePicker
